import { BaseAPIError } from './BaseAPIError'

export class InvalidRequestAPIError extends BaseAPIError {}
